// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2oOl-","title":"Navbar_title__14yQn"};